import { useQueries } from '@tanstack/react-query'
import { oaRankingApi } from '@/api/oa-ranking'
import type { OARankingWidget } from '@/types/oa-ranking'

export const OA_RANKING_WIDGETS: OARankingWidget[] = [
  { title: '本周员工新开数量排名', metric: 'new_orders', dimension: 'employee', period: 'week' },
  { title: '本周部门新开数量排名', metric: 'new_orders', dimension: 'department', period: 'week' },
  { title: '上周员工新开数量排名', metric: 'new_orders', dimension: 'employee', period: 'last_week' },
  { title: '上周部门新开数量排名', metric: 'new_orders', dimension: 'department', period: 'last_week' },
  { title: '本月员工新开数量排名', metric: 'new_orders', dimension: 'employee', period: 'month' },
  { title: '本月部门新开数量排名', metric: 'new_orders', dimension: 'department', period: 'month' },
  { title: '上月员工新开数量排名', metric: 'new_orders', dimension: 'employee', period: 'last_month' },
  { title: '上月部门新开数量排名', metric: 'new_orders', dimension: 'department', period: 'last_month' },
  { title: '当月个人业绩排名', metric: 'performance', dimension: 'employee', period: 'month' },
  { title: '当月部门业绩排名', metric: 'performance', dimension: 'department', period: 'month' },
  { title: '上月个人业绩排名', metric: 'performance', dimension: 'employee', period: 'last_month' },
  { title: '上月部门业绩排名', metric: 'performance', dimension: 'department', period: 'last_month' },
]

export function useOARankings() {
  return useQueries({
    queries: OA_RANKING_WIDGETS.map((widget) => ({
      queryKey: ['oa-rankings', widget.metric, widget.dimension, widget.period] as const,
      queryFn: () => oaRankingApi.getRanking(widget.metric, widget.dimension, widget.period),
      staleTime: 5 * 60 * 1000,
    })),
    combine: (results) => {
      return OA_RANKING_WIDGETS.map((widget, index) => ({
        widget,
        data: results[index].data?.rows ?? [],
        isLoading: results[index].isLoading,
        isError: results[index].isError,
        error: results[index].error,
        refetch: results[index].refetch,
      }))
    },
  })
}
